//Importações do Node Modules
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

//Importação da tela de Dados Iniciais PF
import DadosIniciaisPJ from './dadosIniciaisPJ';

//Importações do store
import {
  changeDadosIniciaisPJValueForm,
  getDadosIniciaisExisteCnpjAction,
  getDadosIniciaisPJGerenteAction,
  resetDadosIniciaisPJ_NomeGerenteAction,
  handleChangeDadosIniciaisPJCNAE,
  getListDadosIniciaisPJCNAEAction,
  setIdDDIPaisDadosIniciaisPJ
} from '../../store/dadosIniciaisPJ/actions';

import {configuracaoDdi} from '../../store/ddi/actions';

const mapStateToProps = (state, nextState) => ({
  dadosIniciaisPJ: state.dadosIniciaisPJReducer,
  ddiReducer: state.ddiReducer,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({
    changeDadosIniciaisPJValueForm,
    getDadosIniciaisExisteCnpjAction,
    getDadosIniciaisPJGerenteAction,
    resetDadosIniciaisPJ_NomeGerenteAction,
    handleChangeDadosIniciaisPJCNAE,
    getListDadosIniciaisPJCNAEAction,
    setIdDDIPaisDadosIniciaisPJ,
    configuracaoDdi
  }, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DadosIniciaisPJ);